export var FONT_FAMILIES=["Arial","Verdana","Lucida","Times New Roman","Courier","Impact","Trebuchet","Georgia"];